import breakpoints from '../lib/breakpoints';

function Toggle() {
  const mediaQuery = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  return {
    isOpen: false,
    isDesktop: false,
    toggle(id = 'toggle', $dispatch) {
      this.isOpen = !this.isOpen;
      $dispatch('toggle', { id });
    },
    handleBpChange(e) {
      if (e.matches) {
        this.isDesktop = true;
      } else {
        this.isDesktop = false;
      }
    },
    init() {
      if (mediaQuery.matches) {
        this.isDesktop = true;
      }
      mediaQuery.addEventListener('change', (e) => this.handleBpChange(e));
    },
  };
}

export default Toggle;
